<template>
  <div>
    <el-dialog title="上传问题描述"  :close-on-click-modal="false" :append-to-body="true" :visible.sync="textDialog" class="imgbox" width="30%" :before-close="resetForm" >
      <!-- excel不合法行数 -->
      <div class="content" v-if="textDesc.illegalDataList.length > 0 || textDesc.notExistDeviceList.length > 0 || textDesc.notReportVersionDeviceList.length > 0">
        <el-row :gutter="10" v-if="textDesc.illegalDataList.length > 0">
          <h2>excel不合法数据所在行数</h2>
          <template v-for="(item,index) in textDesc.illegalDataList" >
            <el-col :key="index">
              {{index+1 + '.    ' + item}}
            </el-col>
          </template>
        </el-row>
        <!-- 设备不存在 -->
        <el-row :gutter="10"  v-if="textDesc.notExistDeviceList.length > 0">
          <h2>以下设备不存在</h2>
          <template v-for="(item,index) in textDesc.notExistDeviceList" >
            <el-col :key="index">
              {{index+1 + '.    ' + item}}
            </el-col>
          </template>
        </el-row>
        <!-- 设备未上报版本 -->
        <el-row :gutter="10" v-if="textDesc.notReportVersionDeviceList.length > 0">
          <h2>以下设备未上报版本</h2>
          <template v-for="(item,index) in textDesc.notReportVersionDeviceList" >
            <el-col :key="index">
              {{index+1 + '.    ' + item}}
            </el-col>
          </template>
        </el-row>
      </div>
      <div v-else>
        <h2 style="text-align:center">暂无问题描述</h2>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

export default {
  props: {
    textDesc: {
      type: Object,
      default: function () {
        return {}
      }
    },
    textDialog: {
      type: Boolean
    }
  },
  data () {
    return {
    }
  },
  created () {
    console.log(this.textDesc)
  },
  methods: {
    resetForm () {
      this.$emit('closeText')
    }
  }
}
</script>

<style lang='less' scoped>
  .content{
    .el-row{
      margin-bottom: 20px;
    }
    h2{
      font-weight: normal;
      padding-left: 4px;
      margin-bottom: 16px;
    }
  }
</style>
